import { BaseClient } from '@/api'

export class PosClientClient extends BaseClient {
  constructor(
  ) {
    super('pos-clients')
  }
}
